/* ENDQUOTE - pagination dots for the mobile product gallery swiper (2026-08-17).
   Self-contained: builds dots from the initialized Swiper instance; no theme JS touched.
   Remove this file + its script tag in layout/theme.liquid to revert. */
(function () {
	function makeDots(swiperEl) {
		var sw = swiperEl.swiper;
		if (!sw || swiperEl.dataset.eqDots) return;
		var slides = swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
		if (slides.length < 2) return;
		swiperEl.dataset.eqDots = '1';
		var nav = document.createElement('div');
		nav.className = 'eq-dots';
		nav.setAttribute('aria-hidden', 'true');
		for (var i = 0; i < slides.length; i++) {
			var d = document.createElement('span');
			d.className = 'eq-dot';
			nav.appendChild(d);
		}
		swiperEl.appendChild(nav);
		function update() {
			var idx = typeof sw.realIndex === 'number' ? sw.realIndex : sw.activeIndex;
			for (var i = 0; i < nav.children.length; i++) {
				nav.children[i].classList.toggle('eq-dot--active', i === idx);
			}
		}
		sw.on('slideChange', update);
		update();
	}
	function init() {
		document
			.querySelectorAll('.product__media-list-wrapper-mobile .js-media-list.swiper')
			.forEach(makeDots);
	}
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
	var tries = 0;
	var t = setInterval(function () {
		init();
		if (++tries > 20) clearInterval(t);
	}, 250);
	document.addEventListener('shopify:section:load', function () {
		setTimeout(init, 300);
	});
})();
